/* Cubold product page: info tabs, at-a-glance cards, trust row, sticky add to cart */
(function () {
  var ICONS = {
    game: '<rect x="2" y="7" width="20" height="11" rx="5"/><path d="M7 10v5M4.5 12.5h5"/><circle cx="16" cy="11.5" r="1"/><circle cx="18.5" cy="14" r="1"/>',
    size: '<path d="M3 17L17 3l4 4L7 21z"/><path d="M7 13l2 2M10 10l2 2M13 7l2 2"/>',
    material: '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>'
  };
  /* Only series, material and physical measurements are highlighted */
  var ALLOW_LABEL = /length|height|width|depth|barrel|blade|handle|grip|size|dimension|diameter|tall|scale/i;
  var DENY_LABEL = /layer|printer|nozzle|infill|print|speed|weight|color|colour|finish|type|category|style|use|includes?/i;
  var MAX_VALUE = 26;

  function iconFor(label) {
    if (/series/i.test(label)) return ICONS.game;
    if (/material/i.test(label)) return ICONS.material;
    return ICONS.size;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initTabs() {
    var root = document.querySelector('[data-cg-tabs]');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
    var current = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    if (current) select(current, false);
  }

  /* Series and material come from the product title, measurements from the Details field */
  function collectFacts() {
    var facts = [];
    var seen = {};
    function add(label, value) {
      var key = label.toLowerCase();
      if (!value || seen[key]) return;
      seen[key] = true;
      facts.push({ label: label, value: value });
    }

    var data = document.querySelector('[data-cg-glance-data]');
    if (data) {
      add('Series', data.getAttribute('data-franchise'));
      add('Material', data.getAttribute('data-material'));
    }

    var panel = document.querySelector('[data-cg-details]');
    if (panel) {
      Array.prototype.slice.call(panel.querySelectorAll('li')).forEach(function (li) {
        var text = (li.textContent || '').trim();
        var idx = text.indexOf(':');
        if (idx < 1) return;
        var label = text.slice(0, idx).trim();
        var value = text.slice(idx + 1).trim();
        if (DENY_LABEL.test(label) || !ALLOW_LABEL.test(label)) return;
        if (value.length > MAX_VALUE || !/\d/.test(value)) return;
        add(label, value);
      });
    }
    return facts.slice(0, 4);
  }

  function buildGlance(anchor) {
    var facts = collectFacts();
    if (facts.length < 2 || !anchor) return;

    var box = document.createElement('div');
    box.className = 'cg-glance';
    var title = document.createElement('p');
    title.className = 'cg-glance__title';
    title.textContent = 'At a Glance';
    var grid = document.createElement('div');
    grid.className = 'cg-glance__grid';

    facts.forEach(function (fact) {
      var card = document.createElement('div');
      card.className = 'cg-glance__card';
      card.innerHTML = '<span class="cg-glance__icon" aria-hidden="true"><svg viewBox="0 0 24 24">' + iconFor(fact.label) + '</svg></span>' +
        '<span class="cg-glance__text"><span class="cg-glance__label"></span><span class="cg-glance__value"></span></span>';
      card.querySelector('.cg-glance__label').textContent = fact.label;
      card.querySelector('.cg-glance__value').textContent = fact.value;
      grid.appendChild(card);
    });

    box.appendChild(title);
    box.appendChild(grid);
    anchor.insertAdjacentElement('afterend', box);
  }

  ready(function () {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    initTabs();

    /* The second title heading only exists for quick add, remove it on the product page */
    info.querySelectorAll('a.product__title').forEach(function (a) { a.remove(); });

    var buy = info.querySelector('product-form');
    var trust = document.querySelector('[data-cg-trust]');
    var anchor = null;

    if (buy) {
      var dynamic = info.querySelector('.shopify-payment-button');
      anchor = dynamic ? (dynamic.closest('div') || dynamic) : buy;
      var affirm = info.querySelector('[class*="affirm"], [id*="affirm"]');
      if (affirm) anchor = affirm.closest('.shopify-block') || affirm;
      if (trust) {
        anchor.insertAdjacentElement('afterend', trust);
        trust.classList.add('is-moved');
        anchor = trust;
      }
      document.querySelectorAll('[data-cg-after-trust]').forEach(function (el) {
        anchor.insertAdjacentElement('afterend', el);
        anchor = el;
      });
      buildGlance(anchor);
    }

    var bar = document.querySelector('[data-cg-sticky]');
    var mainButton = info.querySelector('product-form [type="submit"]');
    if (bar && mainButton) {
      bar.hidden = false;
      var stickyBtn = bar.querySelector('[data-cg-sticky-btn]');

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(mainButton);

      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.getAttribute('data-multi') === 'true') {
          mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainButton.click();
      });

      var drawer = document.querySelector('cart-drawer');
      if (drawer && window.MutationObserver) {
        new MutationObserver(function () {
          document.body.classList.toggle('cg-drawer-open', drawer.classList.contains('active'));
        }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }
  });
})();